import React from "react";
import RangeBar from "./RangeBar";
import { CgmMetricItem } from "src/types/cgm.types";
import { Info } from "@material-symbols-svg/react";

interface CgmMetricCardProps {
  metric: CgmMetricItem;
  onMetricInfoClick: (metric: string) => void;
}

const CgmMetricCard: React.FC<CgmMetricCardProps> = ({
  metric,
  onMetricInfoClick,
}) => {
  const cardType = metric?.name?.toLowerCase().replaceAll(" ", "-") ?? "";

  const handleMetricInfoClick = (cardType: string) => {
    onMetricInfoClick(cardType);
  };

  return (
    <div
      key={metric.name}
      className="relative w-40 min-w-48 max-w-fit border border-gray-200 rounded-lg p-3 pb-6"
    >
      <div className="flex items-center justify-between gap-2">
        <h4 className="text-sm font-medium text-gray-500">{metric.name}</h4>
        <button
          className="p-1 rounded-full hover:bg-gray-100 text-gray-500"
          onClick={() => handleMetricInfoClick(cardType)}
        >
          <Info className="w-4 h-4 text-gray-500" />
        </button>
      </div>
      <p className="text-xl font-bold">
        {metric.value ?? 0} {metric.target.unit}
      </p>
      <RangeBar
        min={metric.target.min}
        max={metric.target.max}
        rangeStart={metric.target.rangeStart}
        rangeEnd={metric.target.rangeEnd}
        value={metric.value ?? 0}
      />
    </div>
  );
};

export default CgmMetricCard;
